import React from "react";
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
} from 'reactstrap';

import AccessorialsAndFeesManageContainer from '../../containers/AccessorialsAndFees/AccessorialsAndFeesManageContainer';
import AccessorialsAndFeesActiveRates from '../../components/AccessorialsAndFees/AccessorialsAndFeesActiveRates';

export default class AccessorialsAndFees extends React.Component {

  render() {

    let { setTerminalId, dispatchUpdateAccessorial, accessorials, uiState, importAccessorials,  dispatchGetAccessorials, self, dispatchGetTerminals, dispatchSetUiState, terminals, terminalObject } = this.props;

    return <div className="animated fadeIn">
      <Row>
        <Col xs="12" md="4" lg='3'>
          <Card>
            <CardHeader>
              Manage
            </CardHeader>
            <CardBody>
              <AccessorialsAndFeesManageContainer />
            </CardBody>
          </Card>
        </Col>
        <Col xs="12" md="8" lg='9'>
          <Card>
            <CardHeader>
              Active Rates
            </CardHeader>
            <CardBody>
              <AccessorialsAndFeesActiveRates
                accessorials={accessorials}
                importAccessorials={importAccessorials}
                self={self}
                uiState={uiState}
                terminalObject={terminalObject}
                dispatchGetAccessorials={dispatchGetAccessorials}
                terminals={terminals}
                dispatchGetTerminals={dispatchGetTerminals}
                setTerminalId={setTerminalId}
                dispatchSetUiState={dispatchSetUiState}
                dispatchUpdateAccessorial={dispatchUpdateAccessorial}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>;
  }
}


// WEBPACK FOOTER //
// ./src/views/AccessorialsAndFees/AccessorialsAndFees.js